__turbopack_context__.v({
  "Logo": "menubar-module__Im73GW__Logo",
  "LogoLeft": "menubar-module__Im73GW__LogoLeft",
  "MenubarContent": "menubar-module__Im73GW__MenubarContent",
});
